import { Tag } from '@indigo-ag/component-module';
import i18next from 'i18next';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { FinancingContact, OpportunityContactRole } from '@indigo-ag/schema';
import { NewPage } from 'core/components';
import { LoadingWrapper } from 'shared';
import { getContactAndOpportunityRoles } from '../../queries/contact.queries';
import { ContactDetailTabs } from './components/ContactDetailTabs';

function useLocationQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const BrazilContactDetailPage: React.FunctionComponent = () => {
  const { contactId, opportunityId } = useParams<{ contactId: string; opportunityId: string }>();
  const query = useLocationQuery();
  const backLink = query.get('backLink') ?? undefined;
  const backLinkLabel: string = query.get('backLinkLabel') ?? i18next.t('goBack');

  return (
    <LoadingWrapper query={getContactAndOpportunityRoles} queryOptions={{ variables: { contactId, opportunityId } }}>
      {({ data, error }) => {
        if (error) {
          return (
            <NewPage backLink={backLink} backLinkLabel={backLinkLabel} title="">
              {i18next.t('error')}
            </NewPage>
          );
        }

        const contact: FinancingContact = data.getContactById;
        const contactRoles: OpportunityContactRole[] = data.opportunityContactRoles;
        const selectedContactRole = contactRoles.find(r => r.contactId === contact.id);

        if (!selectedContactRole) {
          // The contact is not a participant on the opportunity
          return (
            <NewPage backLink={backLink} backLinkLabel={backLinkLabel} title="">
              {i18next.t('error')}
            </NewPage>
          );
        }

        return (
          <NewPage
            title={contact.name}
            backLink={backLink}
            backLinkLabel={backLinkLabel}
            contentRight={
              selectedContactRole?.isPrimary ? (
                <div style={{ marginLeft: '20px' }}>
                  <Tag label={i18next.t('primaryContact')} />
                </div>
              ) : (
                undefined
              )
            }
            displayContentRightAfterHeader
          >
            <ContactDetailTabs contact={contact} contactRoles={contactRoles} selectedRole={selectedContactRole} />
          </NewPage>
        );
      }}
    </LoadingWrapper>
  );
};
